// Insert committed speech at the caret (pure).
//
// The selection is replaced when there is one; otherwise the text goes in at
// the caret. A single space is added on a side only when the neighbouring
// character there is not whitespace, a structural check (`char.trim() === ''`)
// with no pattern over the user's words. The caret lands after the insert.

export type TextSelection = { start: number; end: number };

const isSpace = (char: string) => char.trim() === '';

export function insertTranscript(
  text: string,
  selection: TextSelection,
  transcript: string,
): { text: string; caret: number } {
  const clamp = (value: number) => Math.max(0, Math.min(text.length, Math.trunc(value) || 0));
  const start = clamp(Math.min(selection.start, selection.end));
  const end = clamp(Math.max(selection.start, selection.end));
  const piece = transcript.trim();
  if (!piece) return { text, caret: end };
  const before = text.slice(0, start);
  const after = text.slice(end);
  const lead = before.length > 0 && !isSpace(before.charAt(before.length - 1)) ? ' ' : '';
  const trail = after.length > 0 && !isSpace(after.charAt(0)) ? ' ' : '';
  const inserted = `${lead}${piece}${trail}`;
  return { text: `${before}${inserted}${after}`, caret: before.length + inserted.length };
}
